import { render } from "./propertiesNone.vue?vue&type=template&id=120f97b2"
import script from "./propertiesNone.vue?vue&type=script&lang=js"
export * from "./propertiesNone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__